import { useFormikContext } from 'formik';
import { useEffect } from 'react';

interface ValidForValues {
    _valid: boolean;
}

interface ObserverProps<VALUES> {
    onChange: (values: VALUES & ValidForValues) => void;
}

function PbFormikObserver<VALUES>(props: ObserverProps<VALUES>) {
    const { values, errors } = useFormikContext<VALUES>();
    useEffect(() => {
        const hasNoErrors = Object.getOwnPropertyNames(errors).length === 0;
        props.onChange({
            _valid: hasNoErrors,
            ...values,
        });
    }, [values, errors]);

    return null;
}

export default PbFormikObserver;
